module.exports = __webpack_public_path__ + "static/assets/2b1af79ed038c5e4fce17642213f5f0a.svg";